module.exports = __webpack_public_path__ + "static/img/materials2.90ee19b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materials2.jpg
// module id = ZqEE
// module chunks = 1